import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-dashboard-tab1',
  templateUrl: './admin-dashboard-tab1.component.html',
  styleUrls: ['./admin-dashboard-tab1.component.scss']
})
export class AdminDashboardTab1Component implements OnInit {
  ADFirstKeyData = [
    { 
      stats: 1000,
      title: 'Plan holders'
    },
    { 
      stats: 100,
      title: 'Delegates'
    },
    { 
      stats: 100,
      title: 'New plan holders signed up in last 30 days'
    },
    { 
      stats: 10,
      title: 'Existing plan holders cancelled in last 30 days'
    }
  ]

  ADScdKeyData = [
    { 
      stats: '10%',
      title: '% of plan holders logged in last 90 days'
    },
    { 
      stats: '10%',
      title: '% of plans edited the plan in last 90 days'
    },
    { 
      stats: '50%',
      title: '% of new plan edited in the first 7 days'
    }
  ]
  constructor() { }

  ngOnInit() {
  }

}
